import React, { useState } from 'react';
import i18next from 'i18next';
import {connect} from 'react-redux'

import { Alert, Table } from 'reactstrap'
import ErfassteTeilnahme from './ErfassteTeilnahme';
import { ListOfErfasstenTeilnehmer } from './ListOfErfasstenTeilnehmer';
import { fobiCore } from '../../FobiCore';
import ListenFilter, { MINDESTANZAHL_FUER_FILTER, passtZumFilter } from '../ListenFilter';

function teilnahmenCompare( a, b ) {
  if ( a.addedTimestamp < b.addedTimestamp ){
    return 1;
  }
  if ( a.addedTimestamp > b.addedTimestamp ){
    return -1;
  }
  return 0;
}


const ErfassteTeilnehmer = (props) => { 
	const { vnr, showTeilnahmedatum, erfassteTeilnahmenOfVNR = {}, beschriftungenOfVNR = {}, veranstaltung, highLightRefpunkte = false } = props
	// Der Filter bleibt bewusst lokal und wird nicht im Store gehalten: eine Suche, die
	// einen Seitenwechsel oder Reload ueberlebt, versteckt Zeilen, ohne dass man weiss warum.
	const [filter, setFilter] = useState('');
	const alleTeilnahmen = Object.values(erfassteTeilnahmenOfVNR).sort(teilnahmenCompare)
	const teilnahmen = alleTeilnahmen.filter(t => passtZumFilter(filter, t.efn, beschriftungenOfVNR[t.efn]))
	const keineTeilnahmen = alleTeilnahmen.length === 0;
	const showLernerfolg = fobiCore.isShowLernerfolg(veranstaltung)
	const classNameWithRefPunkte = highLightRefpunkte?"fw-bold text-bg-warning":"";
	if(keineTeilnahmen) return (
		<KeineTeilnehmerErfasst />
	)
  return (
		<>
		{ alleTeilnahmen.length >= MINDESTANZAHL_FUER_FILTER &&
			<ListenFilter wert={filter} onChange={setFilter}
				anzahlGesamt={alleTeilnahmen.length} anzahlAngezeigt={teilnahmen.length} />
		}
		<ListOfErfasstenTeilnehmer className="d-md-none  mb-4" vnr = {vnr} classNameAddOnWithRefPunkte = {classNameWithRefPunkte}
		showTeilnahmedatum={showTeilnahmedatum} showLernerfolg={showLernerfolg} teilnahmen={teilnahmen} veranstaltung={veranstaltung}
		/>
		<Table responsive size="sm" className="mt-4 mb-4 d-none d-md-table">
		<HeaderTeilnahmen showTeilnahmedatum={showTeilnahmedatum} showLernerfolg={showLernerfolg} punkteBasis={veranstaltung.punkte_basis} punkteLernerfolg={veranstaltung.punkte_lernerfolg} />
		<tbody>
    {
			teilnahmen.map(teilnahme => (
				<ErfassteTeilnahme showTeilnahmedatum={showTeilnahmedatum} efn={teilnahme.efn} veranstaltung={veranstaltung} vnr={vnr} 
				className = {teilnahme.punkte_referent > 0?classNameWithRefPunkte:""}
				key={teilnahme.efn} />
      ))}
		</tbody>
  </Table>
	{/* Direkt ueber "Verbindlich melden" und "Alle entfernen": bei gefilterter Liste sieht
	    man eine Zeile und wuerde sechs melden. Der Bestaetigungsdialog nennt zwar die
	    richtige Zahl, aber die Diskrepanz muss schon hier stehen. */}
	{ teilnahmen.length !== alleTeilnahmen.length &&
		<div className="alert alert-warning py-2 small">
			Die Liste ist gefiltert – <b>gemeldet und entfernt werden immer alle {alleTeilnahmen.length} erfassten
			Teilnahmen</b>, nicht nur die {teilnahmen.length} angezeigten.
		</div>
	}
	</>
	);
}

const mapStateToProps = (state, ownProps) => (
	{
		erfassteTeilnahmenOfVNR : state.punkteMeldung.erfassteTeilnahmen[ownProps.vnr],
		beschriftungenOfVNR : state.punkteMeldung.beschriftungen[ownProps.vnr],
		veranstaltung : state.veranstaltungen[ownProps.vnr]
	}
)
export default connect(mapStateToProps)(ErfassteTeilnehmer)

function KeineTeilnehmerErfasst(props) {
  return (
		<Alert color="" className="h6 text-center mt-4 mb-4 lead">
			{i18next.t('keine.teilnehmer.erfasst')}
		</Alert>
	);
}

function HeaderTeilnahmen(props) {
	const { showTeilnahmedatum, showLernerfolg, punkteBasis, punkteLernerfolg } = props
  return (
		<thead>
			<tr>
				<th>EFN</th>
				<th>Name / Notiz</th>
				{ showTeilnahmedatum &&
					<th>Teilnahmedatum</th>
				}
				<th>Teilnahme ({punkteBasis} Pkt.)</th>
				{ showLernerfolg &&
				<th>
					<span className=" d-lg-none">Lernerfolg ({punkteLernerfolg} Pkt.)</span>
					<span className="d-none d-lg-inline" >Lernerfolg ({punkteLernerfolg} Pkt.)</span>
				</th>
				}
				<th title="Kategorie (F) Punkte für Referent, Moderator, Wiss. Leitung">
					<span className="d-lg-none">Ref/Mod/WL Pkte.</span>
					<span className="d-none d-lg-inline">Referent, Moderation, wiss. Leitung</span>
				</th>
				<th></th>			
				</tr>
			</thead>
	);
}